import React from "react";
import * as Icons from "lucide-react";

export function PageHeader({ eyebrow, title, subtitle, actions, icon }) {
  const Icon = icon ? (Icons[icon] || Icons.Circle) : null;
  return (
    <div className="mb-7 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && <div className="label-eyebrow mb-1.5">{eyebrow}</div>}
        <div className="flex items-center gap-3">
          {Icon && (
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#0B1729] text-[#FFC24D]">
              <Icon size={20} strokeWidth={1.75} />
            </span>
          )}
          <h1 className="font-display text-2xl font-bold tracking-tight text-[#0B1729] sm:text-3xl">
            {title}
          </h1>
        </div>
        {subtitle && <p className="mt-1.5 max-w-2xl text-sm text-[#1E2D44]/60">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
